module.exports = __webpack_public_path__ + "img/GTQ.f33194f6.svg";